export default {
  // 搜索相关
  searchPlaceholder: "搜索地址/哈希/调证用户ID",
  dataDetails: "数据详情",

  // 页面标题
  transactionDetails: "交易详情",

  // 按钮
  joinCanvas: "加入画布",
  browserView: "浏览器查看",

  // 交易信息
  transactionHash: "交易哈希值",
  blockTime: "出块时间",
  inputAmount: "输入数量",
  outputAmount: "输出数量",
  transactionFee: "交易手续费",

  // 消息提示
  copySuccess: "复制成功",
  addressNotFound: "没有查出该地址",
};
